const styles = {
  text: {
    fontWeight: 700,
    fontFamily: 'inherit',
  },
};

export default styles;
